import styles from './PublicSimplePage.scss';

import { ReferencedEntry } from 'contentful';
import React from 'react';
import * as PublicContentfulSpace from 'src/api/contentful/contentTypes.public';
import { Blurb } from '../Contentful/Blurb';

export const SectionDocument: React.FC<{entry?: ReferencedEntry<PublicContentfulSpace.SectionDocument>}> = ({ entry }) => {
  if (!entry) { return null; }

  // old pages have html tables, not markdown tables
  return <Blurb className={styles.blurb} entry={entry} field="body" skipHtml={false} escapeHtml={false} />;
};
